<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>智能人事</Breadcrumb-item>
        <Breadcrumb-item>{{ groupName }}</Breadcrumb-item>
        <Breadcrumb-item>{{ title }}</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Alert type="info" show-icon class="tip">
      本模块为后台本地维护，不与钉钉同步；新增/修改仅落本地库。
    </Alert>
    
    <div class="search">
      <Form inline :label-width="60" :show-message="false">
        <Form-item label="状态">
          <Select v-model="query.status" style="width:140px;" clearable @on-change="search">
            <Option value="OPEN">进行中</Option>
            <Option value="DONE">已完成</Option>
            <Option value="CANCEL">已取消</Option>
          </Select>
        </Form-item>
        <Form-item label="关键字">
          <Input v-model="query.keyword" placeholder="员工/标题" style="width:180px;" @on-enter="search"/>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="search">查询</Button>
        </Form-item>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="success" @click="openAdd">新增</Button>
    </div>
    <Table :columns="columns" :data="rows" :loading="loading" stripe :no-data-text="'暂无' + title + '记录'"></Table>
    <div style="margin-top:12px;text-align:right;">
      <Page :total="total" :current="query.pageIndex" :page-size="query.pageSize"
            show-total @on-change="p => { query.pageIndex=p; load() }"/>
    </div>
    <Modal v-model="showForm" :title="(form.id ? '编辑' : '新增') + title" @on-ok="save">
      <Form :label-width="90">
        <Form-item label="员工姓名"><Input v-model="form.empName"/></Form-item>
        <Form-item label="钉钉userId"><Input v-model="form.dingUserId"/></Form-item>
        <Form-item label="标题"><Input v-model="form.title"/></Form-item>
        <Form-item label="状态">
          <Select v-model="form.status">
            <Option value="OPEN">进行中</Option>
            <Option value="DONE">已完成</Option>
            <Option value="CANCEL">已取消</Option>
          </Select>
        </Form-item>
        <Form-item label="内容"><Input v-model="form.content" type="textarea" :rows="3"/></Form-item>
        <Form-item label="备注"><Input v-model="form.remark" type="textarea"/></Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'SmartHrLocalList',
  props: {
    moduleType: { type: String, required: true },
    title: { type: String, required: true },
    groupName: { type: String, default: '员工关系' }
  },
  data () {
    return {
      loading: false,
      showForm: false,
      rows: [],
      total: 0,
      query: { pageIndex: 1, pageSize: 20, status: '', keyword: '', moduleType: this.moduleType },
      form: {},
      columns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '员工', key: 'empName', minWidth: 120 },
        { title: '标题', key: 'title', minWidth: 160 },
        { title: '状态', key: 'status', width: 100,
          render: (h, { row }) => h('span', this.statusText(row.status)) },
        { title: '备注', key: 'remark', minWidth: 140 },
        { title: '更新时间', key: 'gmtModified', minWidth: 160 },
        { title: '操作', width: 90, fixed: 'right',
          render: (h, { row }) => h('a', { on: { click: () => this.openEdit(row) } }, '编辑') }
      ]
    }
  },
  created () { this.load() },
  methods: {
    stripReadonlyTimes (obj) {
      if (!obj || typeof obj !== 'object') return obj
      const payload = Object.assign({}, obj)
      delete payload.gmtCreate
      delete payload.gmtModified
      delete payload.syncedAt
      return payload
    },
    statusText (s) {
      if (s === 'OPEN') return '进行中'
      if (s === 'DONE') return '已完成'
      if (s === 'CANCEL') return '已取消'
      return s || '-'
    },
    search () { this.query.pageIndex = 1; this.load() },
    load () {
      this.loading = true
      this.query.moduleType = this.moduleType
      this.$http.post('/smartHr/local/page', this.query).then(res => {
        if (res && res.status === 'ok' && res.data) {
          this.rows = res.data.data || []
          this.total = res.data.totalCount || 0
        }
      }).finally(() => { this.loading = false })
    },
    openAdd () {
      this.form = { moduleType: this.moduleType, empName: '', dingUserId: '', title: '', status: 'OPEN', content: '', remark: '' }
      this.showForm = true
    },
    openEdit (row) {
      this.form = Object.assign({}, row)
      this.showForm = true
    },
    save () {
      const url = this.form.id ? '/smartHr/local/update' : '/smartHr/local/add'
      const payload = this.stripReadonlyTimes(this.form)
      this.$http.post(url, payload).then(res => {
        if (res && res.status === 'ok') {
          this.$Message.success('已保存（仅本地）')
          this.showForm = false
          this.load()
        }
      })
    }
  }
}
</script>
<style scoped>
.tip { margin-bottom: 12px; }
.btn-wrap {
  margin: 8px 0 12px;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// SmartHrLocalList.vue?471fac1f